'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const usePanGesture = require('./use-pan-gesture.js');
const useTapGesture = require('./use-tap-gesture.js');
const useHoverGesture = require('./use-hover-gesture.js');
const useFocusGesture = require('./use-focus-gesture.js');

/**
 * Add pan and tap gesture recognition to an element.
 *
 * @param props - Gesture event handlers
 * @param ref - React `ref` containing a DOM `Element`
 * @public
 */
function useGestures(props, visualElement) {
  usePanGesture.usePanGesture(props, visualElement);
  useTapGesture.useTapGesture(props, visualElement);
  useHoverGesture.useHoverGesture(props, visualElement);
  useFocusGesture.useFocusGesture(props, visualElement);
}

exports.useGestures = useGestures;
